<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            multi-sort
            locale="de"
            no-data-text="Es liegen noch keine Daten vor."
            no-results-text="Es wurden keine Ergebnisse gefunden."
            loading-text="Lädt..."
            :footer-props="{
                            itemsPerPageText: 'Einträge pro Seite',
                            itemsPerPageOptions: [10,25,50,100, -1],
                            itemsPerPageAllText: 'Alle'
                        }"

    >
        <template v-slot:item.action="{ item }">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs}">
                    <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            icon
                            :to="{ name: 'EmployeeInterviewsEdit', params: { id: item.id }, query: {type: type}}"
                            exact
                    >
                        <v-icon>mdi-eye</v-icon>
                    </v-btn>
                </template>
                <span>Ansicht</span>
            </v-tooltip>
        </template>
        <template v-slot:item.is_released="{ item }">
            <v-tooltip left v-if="item.is_released_conclusion">
                <template v-slot:activator="{ on, attrs}">
                    <v-chip
                            v-bind="attrs"
                            v-on="on"
                            color="green"
                    >Z</v-chip>
                </template>
                <span>Zusammenfassung freigegeben</span>
            </v-tooltip>
            <v-tooltip left v-else>
                <template v-slot:activator="{ on, attrs}">
                    <v-chip
                            v-bind="attrs"
                            v-on="on"
                    >Z</v-chip>
                </template>
                <span>Zusammenfassung nicht freigegeben</span>
            </v-tooltip>

            <v-tooltip left v-if="item.is_released_risk && ($can('show risk own') || $can('show risk employee') || $can('show interview'))">
                <template v-slot:activator="{ on, attrs}">
                    <v-chip
                            v-bind="attrs"
                            v-on="on"
                            color="green"
                    >R</v-chip>
                </template>
                <span>Risikobewertung freigegeben</span>
            </v-tooltip>
            <v-tooltip left v-else>
                <template v-slot:activator="{ on, attrs}">
                    <v-chip
                            v-bind="attrs"
                            v-on="on"
                    >R</v-chip>
                </template>
                <span>Risikobewertung nicht freigegeben</span>
            </v-tooltip>
        </template>
    </v-data-table>
</template>

<script>
    export default {
        props: ['headers', 'search', 'items', 'type'],
        name: "employee-interviews-utility-interviews-data-table",
        created() {
        }
    }
</script>

<style scoped>

</style>